export default "__VITE_ASSET__9bOn3J_w__"